module.exports = __webpack_public_path__ + "img/bilibili.494b5a9f.png";